// Port of webapp/src/pages/registerPage.tsx — POST /api/v2/register, then the
// same sign-in path as LoginPage.

import {FormEvent, ReactElement, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import client from '../api/client'
import {useUsers} from '../store/users'
import {onLoggedIn} from '../store/initialLoad'

export default function RegisterPage(): ReactElement {
    const navigate = useNavigate()
    const login = useUsers((state) => state.login)
    const [email, setEmail] = useState('')
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [busy, setBusy] = useState(false)

    const submit = async (event: FormEvent): Promise<void> => {
        event.preventDefault()
        setBusy(true)
        setError('')
        const result = await client.register(email.trim(), username.trim(), password)
        if (result.code !== 200) {
            setError(result.json.error || '注册失败。')
            setBusy(false)
            return
        }
        const ok = await login(username.trim(), password)
        if (!ok) {
            setError('账号已创建，但自动登录失败，请手动登录。')
            setBusy(false)
            return
        }
        const teamId = await onLoggedIn()
        navigate(teamId ? `/team/${teamId}` : '/', {replace: true})
    }

    return (
        <div className='flex h-full items-center justify-center bg-main-bg px-4'>
            <form onSubmit={submit} className='w-full max-w-[380px] space-y-4'>
                <h1 className='text-xl font-bold'>注册账号</h1>

                <Field id='email' label='邮箱' value={email} onChange={setEmail} type='email'/>
                <Field id='username' label='用户名' value={username} onChange={setUsername}/>
                <Field id='password' label='密码' value={password} onChange={setPassword} type='password'/>

                {error && <div className='rounded bg-[#d8002e]/10 px-3 py-2 text-sm text-[#d8002e]'>{error}</div>}

                <button type='submit' className='Button Button--primary w-full' disabled={busy || !email || !username || !password}>
                    {busy ? '创建中……' : '注册账号'}
                </button>

                <div className='text-sm opacity-70'>
                    已有账号？ <Link to='/login'>登录</Link>
                </div>
            </form>
        </div>
    )
}

function Field({id, label, value, onChange, type = 'text'}: {
    id: string
    label: string
    value: string
    onChange: (value: string) => void
    type?: string
}): ReactElement {
    return (
        <div>
            <label className='mb-1 block text-xs font-semibold uppercase opacity-60' htmlFor={id}>{label}</label>
            <input
                id={id}
                type={type}
                className='w-full rounded border border-main-fg/20 bg-transparent px-3 py-2 outline-none focus:border-button-bg'
                value={value}
                autoComplete='off'
                onChange={(event) => onChange(event.target.value)}
            />
        </div>
    )
}
